import React from 'react'
import {Form, Input, Button, Row, Col, Typography, message} from "antd";
import validator from 'validator';
import {RightOutlined} from '@ant-design/icons';
import {useAuth} from "../../hooks";
import {collection, query, where, getDocs} from "firebase/firestore";
import {firestore} from '../../services/firebase';


const Login = () => {

  const {Title} = Typography;
  const {signIn} = useAuth();

  const onFinish = async (values) => {

    let {input_value} = values;
    let tipoDato = ''


    if (validator.isEmail(input_value)) {
      tipoDato = 'correo';
    } else if (validator.isNumeric(input_value) && input_value.length === 10) {
      tipoDato = 'telefono';
      input_value = parseInt(input_value);
    } else {
      message.warning('Ingresa un correo electrónico o un número de teléfono.');
      return false;
    }

    const q = query(collection(firestore, "usuarios"), where(tipoDato, "==", input_value));
    const querySnapshot = await getDocs(q);

    console.log(querySnapshot, tipoDato, input_value)

    let count = 0;
    querySnapshot.forEach((doc) => {
      if (doc.data().estatus > 0) {
        count++;
        signIn(doc.data(), doc.id)
      }
    });
    if (count > 0) {
      message.success('Bienvenido')
    } else {
      message.warning('Datos incorrectos o usuario inactivo.')
    }

  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <>
      <Form
        name="basic"
        layout="vertical"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row
          gutter={{xs: 10, sm: 10, md: 10, lg: 10}}
          style={{marginLeft: 0, marginTop: 20, marginBottom: 20}}
        >
          <Title level={4}>Ingresar</Title>
        </Row>

        <Row gutter={{xs: 10, sm: 10, md: 10, lg: 10}}>

          <Col
            xs={{span: 24, offset: 0}}
            sm={{span: 24, offset: 0}}
            md={{span: 24, offset: 0}}
            lg={{span: 24, offset: 0}}
            xxl={{span: 24, offset: 0}}
          >
            <Form.Item
              label="Ingrese su teléfono o correo electrónico"
              name="input_value"
              rules={[{required: true, message: "No dejar vacio"}]}
            >
              <Input autoComplete="off"/>
            </Form.Item>
          </Col>


        </Row>

        <Row gutter={{xs: 10, sm: 10, md: 10, lg: 10}}>
          <Col
            xs={{span: 24, offset: 0}}
            sm={{span: 24, offset: 0}}
            md={{span: 24, offset: 0}}
            lg={{span: 24, offset: 0}}
            xxl={{span: 24, offset: 0}}
          >
            <Form.Item>
              <Button
                icon={<RightOutlined/>}
                type="primary"
                htmlType="submit"
                block
                size="large"
              >
                Ingresar
              </Button>
            </Form.Item>
          </Col>
        </Row>

      </Form>
    </>
  )
}

export default Login
